module.exports = __webpack_public_path__ + "static/img/banner3.d41173d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone/banner3.jpg
// module id = w1Dg
// module chunks = 2